/* global fbq, ttq */
import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useEffect,
} from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  // Load cart from localStorage on component mount
  useEffect(() => {
    const storedCart = localStorage.getItem("cartItems");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  // Save cart to localStorage whenever cartItems change
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (itemId, selectedSize, itemName, itemPrice) => {
    setCartItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (i) => i.id === itemId && i.size === selectedSize
      );

      // // Trigger fbq AddToCart
      // if (window.fbq) {
      //   fbq("track", "AddToCart", {
      //     content_ids: [itemId],
      //     content_type: "product",
      //     content_name: `${itemId} (${selectedSize})`,
      //     currency: "GBP",
      //   });
      // }

      // // Trigger TikTok Pixel AddToCart
      // if (window.ttq) {
      //   ttq.track("AddToCart", {
      //     contents: [
      //       {
      //         content_id: itemId,
      //         content_type: "product",
      //         content_name: `${itemId} (${selectedSize})`,
      //       },
      //     ],
      //     currency: "GBP",
      //   });
      // }


        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "addToCart",
          ecommerce: {
            currency: "GBP", 
            value: itemPrice, 
            items: [
              {
                item_id: itemId,
                item_name: itemName,
                quantity: 1,
                price: itemPrice
              }
            ]
          }
        });

      if (existingItemIndex > -1) {
        return prevItems.map((i, index) =>
          index === existingItemIndex ? { ...i, quantity: i.quantity + 1 } : i
        );
      } else {
        // Item doesn't exist, add new item with quantity 1
        return [...prevItems, { id: itemId, size: selectedSize, quantity: 1 }];
      }
    });
  };

  const removeOneFromCart = (itemId, size) => {
    setCartItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (i) => i.id === itemId && i.size === size
      );
      if (existingItemIndex > -1 && prevItems[existingItemIndex].quantity > 1) {
        return prevItems.map((item, index) =>
          index === existingItemIndex
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
      } else {
        return prevItems.filter(
          (item) => item.id !== itemId || item.size !== size
        );
      }
    });
  };

  const removeFromCart = (itemId, size) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => item.id !== itemId || item.size !== size)
    );
  };

  // New function to clear cart after checkout
  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cartItems");
  };

  // Memoizing the context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({
      cartItems,
      addToCart,
      removeOneFromCart,
      removeFromCart,
      clearCart,
    }),
    [cartItems]
  ); // dependency array includes only cartItems since it's the only part of the state that triggers updates

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
